import React from "react";

interface Login_BgProps {
  height?: string; // Optional to allow default styles
  width?: string; // Optional to allow default styles
  style?: React.CSSProperties; // Allow passing additional styles
}

const Login_Bg: React.FC<Login_BgProps> = ({
  height = "100%",
  width = "100%",
  style,
}) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 841 1107"
      //   style={{
      //     position: "absolute", // Ensures it's positioned correctly in the background
      //     top: 0,
      //     left: 0,
      //     objectFit: "cover", // Scales SVG properly
      //     zIndex: -1, // Ensures it's behind other elements
      //     ...style, // Allows additional custom styles
      //   }}
    >
      <path
        fill="url(#paint0_linear_515_327)"
        d="M678.251-256 1242 551.425V1137H0z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_515_327"
          x1="-658.389"
          x2="616.658"
          y1="323.316"
          y2="824.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08163B"></stop>
          <stop offset="0.394" stopColor="#0F2D49"></stop>
          <stop offset="1" stopColor="#1B545E"></stop>
          <stop offset="1" stopColor="#2B867C"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Login_Bg;
